import BunkeyAPI from '../api/BunkeyAPI'
import {
  GET_TRASH_ITEMS,
  GET_TRASH_ITEMS_SUCCESS,
  GET_TRASH_ITEMS_FAILURE,
  CLEAR_ALL_TRASH,
  CLEAR_ALL_TRASH_SUCCESS,
  CLEAR_ALL_TRASH_FAILURE,
  RESTORE_ASSETS,
  RESTORE_ASSETS_SUCCESS,
  RESTORE_ASSETS_FAILURE,
  DELETE_ASSETS,
  DELETE_ASSETS_SUCCESS,
  DELETE_ASSETS_FAILURE,
  MOVE_ASSETS,
  MOVE_ASSETS_SUCCESS,
  MOVE_ASSETS_FAILURE,
  DOWNLOAD_ASSETS,
  DOWNLOAD_ASSETS_SUCCESS,
  DOWNLOAD_ASSETS_FAILURE,
  GET_TRASH_USAGE_LIST,
  GET_TRASH_USAGE_LIST_SUCCESS,
  GET_TRASH_USAGE_LIST_FAILURE
} from "../constants/trash-types";
import Socket from '../utils/sockets';
import { TRASH_PAGE_SIZE } from '../utils';

// La papelera ahora se pide paginada y filtrada al servidor. Antes se traia
// completa (varios MB en clientes grandes) y el filtrado ocurria en el navegador.
export const getTrashItems = (workclient, filtros = {}) => {
  const {
    search = '',
    type = '',
    fromDate = '',
    toDate = '',
    page = 1,
    limit = TRASH_PAGE_SIZE,
  } = filtros;

  const params = { page, limit };
  if (search) params.search = search;
  if (type) params.type = type;
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;

  return dispatch => {
    dispatch({ type: GET_TRASH_ITEMS })
    BunkeyAPI({
      url: `clients/${workclient}/objectsbin`,
      method: 'GET',
      params,
    }).then(resp => {
        dispatch({
            type: GET_TRASH_ITEMS_SUCCESS,
            payload: {
                items: resp.data,
                // El total viene en la cabecera de paginacion, expuesta por CORS
                // tanto en el gateway como en bunkey.objects.
                total: parseInt(resp.headers['x-pagination-total-count'], 10) || 0,
                page,
            }
        })
    }).catch(err => {
      dispatch({
        type: GET_TRASH_ITEMS_FAILURE,
        payload: err
      })
    })
  }
}
export const clearAllTrash = (workclient, items) => {
  return dispatch => {
    dispatch({ type: CLEAR_ALL_TRASH })
    BunkeyAPI({
      url: `clients/${workclient}/objects-emptymany`,
      method: 'DELETE',
      data: {
        data: items
      }
    }).then(resp => {
        dispatch({
            type: CLEAR_ALL_TRASH_SUCCESS,
            payload: {}
        })
    }).catch(err => {
      dispatch({
        type: CLEAR_ALL_TRASH_FAILURE,
        payload: err
      })
    })
  }
}
export const restoreAssets = (workclient, items) => {
  return dispatch => {
    dispatch({ type: RESTORE_ASSETS })
    BunkeyAPI({
      url: `clients/${workclient}/objects-restorefiles`,
      method: 'PUT',
      data: {
        data: items
      }
    }).then(resp => {
        dispatch({
            type: RESTORE_ASSETS_SUCCESS,
            payload: {}
        })
    }).catch(err => {
      dispatch({
        type: RESTORE_ASSETS_FAILURE,
        payload: err
      })
    })
  }
}
export const deleteAssets = (workclient, items) => {
  return dispatch => {
    dispatch({ type: DELETE_ASSETS })
    BunkeyAPI({
      url: `clients/${workclient}/objects-emptymany`,
      method: 'DELETE',
      data: {
        data: items
      }
    }).then(resp => {
        dispatch({
            type: DELETE_ASSETS_SUCCESS,
            payload: {}
        })
    }).catch(err => {
      dispatch({
        type: DELETE_ASSETS_FAILURE,
        payload: err
      })
    })
  }
}
export const moveAssets = (workclient, items, folder) => {
  return dispatch => {
    dispatch({ type: MOVE_ASSETS })
    BunkeyAPI({
      url: `clients/${workclient}/objects-restore-move/${folder}`,
      method: 'POST',
      data: {
        data: items
      }
    }).then(resp => {
        dispatch({
          type: MOVE_ASSETS_SUCCESS,
          payload: {}
        })
    }).catch(err => {
      dispatch({
        type: MOVE_ASSETS_FAILURE,
        payload: err
      })
    })
  }
}
export const downloadAssets = (workclient, selectedFiles, intl) => {
  return dispatch => {
    dispatch({ type: DOWNLOAD_ASSETS });
    const filesBody = selectedFiles.map(e => ({
      name: e.name,
      id: e._id,
    }));
    BunkeyAPI({
      url: `/downloads/${workclient}/dowload/multiple`,
      method: 'POST',
      data: {
        files: filesBody
      }
    }).then(resp => {
      const dataToDownload = resp.data;
      if(dataToDownload.length === 0){
        dispatch({
          type: DOWNLOAD_ASSETS_FAILURE,
          payload: {
            message: intl.formatMessage({id: "move-download-empty-folder"})
          }
        });
        return;
      }
      BunkeyAPI({
        url: `/downloads/client-multi/${workclient}`,
        method: 'POST',
        data: {
          data: dataToDownload.map(e => e.id),
          status: 'success'
        }
      });
      const uuid = Socket.getInstance().id
      this.props.startDownload({
        id: uuid,
        uuid: uuid,
        name: 'compressed',
        state: 'download_in_progress',
        client: !workclient
          ? uuid
          : workclient,
        quality: 'original',
      });
      Socket.getInstance().emit(
        'download_gpt_listener_from_lambda'
      ,{
        id: uuid,
        env: process.env.REACT_APP_BUNKEY_ENV ? process.env.REACT_APP_BUNKEY_ENV : 'qa',
        files: dataToDownload,
      });
      dispatch({
        type: DOWNLOAD_ASSETS_SUCCESS,
        payload: {}
      })
    }).catch(err => {
      dispatch({
        type: DOWNLOAD_ASSETS_FAILURE,
        payload: err
      })
    });
  }
}

export const getTrashUsageList = (workclient, intl) => {
  return dispatch => {
    dispatch({ type: GET_TRASH_USAGE_LIST })
    BunkeyAPI({
      url: `/clients/${workclient}/objectsbin/quantitybin`,
      method: 'GET',
    }).then(resp => {
      if (resp && resp.status === 200) {
        dispatch({
          type: GET_TRASH_USAGE_LIST_SUCCESS,
          payload: {
            assetList: [
              {
                title: intl.formatMessage({id: 'videos'}),
                qty: resp.data['videos'],
                background: '#F8BA0A',
                type: 'video'
              },
              {
                title: intl.formatMessage({id: 'files-audios'}),
                qty: resp.data['audios'],
                background: '#FFAEED',
                type: 'audio'
              },
              {
                title: intl.formatMessage({id: 'images'}),
                qty: resp.data['images'],
                background: '#BED9FA',
                type: 'image'
              },
              {
                title: intl.formatMessage({id: 'files-fonts'}),
                qty: resp.data['fonts'],
                background: '#19D491',
                type: 'font'
              },
              {
                title: intl.formatMessage({id: 'documents'}),
                qty: resp.data['documents'],
                background: '#DEAAD3',
                type: 'document'
              },
              {
                title: intl.formatMessage({id: 'files-others'}),
                qty: resp.data['others'],
                background: '#3AA52B',
                type: 'other'
              },
            ],
            totalAssets: resp.data['videos'] + resp.data['audios'] + resp.data['images'] + resp.data['fonts'] + resp.data['documents'] + resp.data['others'] + resp.data['fonts'],
            // Peso total de la papelera completa, calculado en el servidor.
            totalSize: resp.data['totalSize'] || 0
          }
        })
      }else{
        dispatch({
          type: GET_TRASH_USAGE_LIST_FAILURE,
          payload: {}
        })
      } 
    }).catch(err => {
      dispatch({
        type: GET_TRASH_USAGE_LIST_FAILURE,
        payload: err
      })
    })
  }
}


